export default __webpack_public_path__ + "static/image3-2f0b586a06d391b73c1791ed71a1fccb.jpg";